module.exports = __webpack_public_path__ + "media/images/cvbtn-7d7da1e19d1848292badd22ecebb1a70.png";